import { Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Check, X } from "react-feather";
import Modal from "react-modal";
import { useNavigate } from "react-router";
import { useAvaliacao } from "../../../Hooks/avaliado";
import { useCartorio } from "../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/api";
import theme from "../../../Styles/theme";
import { app_base_url, base_url_unico_api } from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { retiraVerificadores } from "../../../Utils/retiraVerificadores";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";
import { IAdquirinte } from "../Adquirinte";
import { ITransmitente } from "../Transmitente";
import { Container, HelperButtons, Item, Lista, Span, Title } from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
}

export function ExcluirImovelModal({ open, onClose, imovel }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const { cartorioIsLogged, checarToken } = useCartorio();
  const { avaliado, createAvaliacao, updateAvaliacao } = useAvaliacao();
  const {
    prefeituraIsLogged,
    checarTokenPrefeitura,
    bancoPrefeitura,
    carregaLogo,
  } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    checarTokenFuncionarioPrefeitura,
    FuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const navigate = useNavigate();

  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  async function execute() {
    try {
      if (cartorioIsLogged) {
        await checarToken();
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }

      setLoading(true);

      const { data } = await api.delete(
        `/imovel${isRural() ? "-rural" : ""}/${imovel.ID}`
      );

      await new Promise((r) => setTimeout(r, 10000));
      setLoading(false);
      navigate(`${app_base_url}/imoveis${isRural() ? "-rural" : ""}`);
    } catch (error) {
      setError({
        message:
          "Não foi possível excluir o imovel, tente novamente mais tarde!",
        title: "Ops",
      });
      setLoading(false);
    } finally {
      // setLoading(false);
    }
  }

  useEffect(() => {
    carregaLogo(imovel.PREFEITURA_ID);
  }, []);

  useEffect(() => {
    if (funcionarioCartorioIsLogged) {
      checarTokenFuncionario();
    }
    if (cartorioIsLogged) {
      checarToken();
    }
    if (prefeituraIsLogged) {
      checarTokenPrefeitura();
    }
    if (funcionarioPrefeituraIsLogged) {
      checarTokenFuncionarioPrefeitura();
    }
  }, [open]);

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <Typography
          variant="h5"
          style={{ color: theme.colors.dark, fontWeight: "bold" }}
        >
          Tem certeza que deseja <span style={{color:theme.colors.attention}}>EXCLUIR PERMANENTEMENTE</span>  este imóvel?
        </Typography>
        <br />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          <Button
            onClick={() => onClose()}
            variant="contained"
            style={{ fontWeight: "bold" }}
          >
            CANCELAR
          </Button>

          <Button
            onClick={() => execute()}
            variant="contained"
            color="error"
            style={{ fontWeight: "bold" }}
          >
            EXCLUIR
          </Button>
        </div>
      </Container>

      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
